export default {
    logout: 'logout'
}
